<template>
  <div class="newReview">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleCloseNewReview"
      :close-on-click-modal="false"
      :append-to-body="false"
    >
      <p class="title pl14">
        <i class="iconfont icon-xinjian mr8"></i>
        新建审查
      </p>
      <div class="content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="整篇审查" name="file" v-loading="loadingFile">
            <el-form class="reviewForm" ref="ruleFormFile" :model="ruleFormFile">
              <el-form-item label="待审文件上传" class="proGuide" prop="proGuide">
                <el-input v-model="ruleFormFile.proGuide" readonly="readonly"></el-input>
                <a
                  @click="uploadFileFun"
                  class="uploadFile fl el-icon-folder-opened"
                  title="上传文件"
                ></a>
                <input
                  type="file"
                  @change="uploadFile"
                  ref="file"
                  style="display: none"
                />
              </el-form-item>
              <a class="startReview wid100 hlh56 tac bdr3" @click="wholeReviewFun"
                >开始审查</a
              >
              <div class="tips pt15 pb19 tac lh24 mt16">
                <p style="text-align: left">
                  <i class="iconfont icon-ziyuan mr8 fwb"></i>
                  <!-- <span> DOCX，DOC，PDF </span>或<span> TXT </span> -->
                  注意：请选择待审查的规范性文件进行上传，文件格式应为<span>
                    DOC、DOCX 或 PDF</span
                  >，文件大小不超过<span> 5MB</span
                  >，并需确认上传文件必须拥有正规内容命名的"文件标题"。
                </p>
                <!-- <p>请确认上传文件必须包含"文件标题"</p> -->
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="条目审查" name="item" v-loading="loadingItem">
            <div class="reviewItem mb15">
              <p class="title pl19">待审条目内容</p>
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 6 }"
                placeholder="请输入条目内容"
                v-model.trim="itemCon"
              ></el-input>
            </div>
            <a class="startReview wid100 hlh56 tac bdr3" @click="itemReviewFun"
              >开始审查</a
            >
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false, //弹窗是否显示
      activeName: "file", //当前显示的标签页 file整篇审查 item条目审查
      fileData: null, //获取的上传的文件对象
      ruleFormFile: {
        //整篇审查
        proGuide: "", //获取的上传的文件名
      },
      loadingFile: false, //整篇审查加载中
      itemCon: "", //条目内容
      loadingItem: false, //条目审查加载中

      uuid: "", //开始审查之后返回的uuid
    };
  },
  created() {},
  methods: {
    //弹窗显示
    childFun() {
      this.dialogVisible = true;
    },
    //弹窗关闭按钮
    handleCloseNewReview() {
      this.ruleFormFile.proGuide = "";
      this.fileData = null;
      this.activeName = "file";
      this.dialogVisible = false;
    },

    //tabs切换
    handleClick(tab, event) {
      //   console.log(tab, event);
    },
    //上传文档-获取上传的名称
    uploadFile(ev) {
      var objFile = ev.target.files[0];
      console.log(objFile);
      this.ruleFormFile.proGuide = objFile.name;

      // if (
      // 	this.ruleFormFile.proGuide.substring(
      // 		this.ruleFormFile.proGuide.length - 3
      // 	) == "doc"||this.ruleFormFile.proGuide.substring(
      // 		this.ruleFormFile.proGuide.length - 4
      // 	) == "docx"||this.ruleFormFile.proGuide.substring(
      // 		this.ruleFormFile.proGuide.length - 3
      // 	) == "txt"||this.ruleFormFile.proGuide.substring(
      // 		this.ruleFormFile.proGuide.length - 3
      // 	) == "pdf"
      // )
      let typeArr = ["doc", "DOC", "docx", "DOCX", "pdf", "PDF"];
      if (
        typeArr.indexOf(
          this.ruleFormFile.proGuide.substring(this.ruleFormFile.proGuide.length - 3)
        ) > -1 ||
        typeArr.indexOf(
          this.ruleFormFile.proGuide.substring(this.ruleFormFile.proGuide.length - 4)
        ) > -1
      ) {
        //上传之后直接提交
        this.fileData = objFile;
        //解决文件名无法重复上传的问题
        this.$refs.file.value = null;
      } else {
        this.$message({
          message: "上传文件格式不对，请重新上传！", //请上传doc、docx、txt、或者pdf文档！
          type: "warning",
          duration: 3000,
        });
        this.ruleFormFile.proGuide = "";
        this.fileData = null;
        //解决文件名无法重复上传的问题 避免无法重复上传同一文档的情况
        this.$refs.file.value = null;
      }
    },
    //通过点击上传文档触发type="file"的功能
    uploadFileFun() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    //整篇审查
    wholeReviewFun() {
      if (this.fileData) {
        //遮罩显示
        this.loadingFile = true;
        // let title=this.ruleFormFile.proGuide.split('.')[0];
        let title = this.ruleFormFile.proGuide.substring(
          0,
          this.ruleFormFile.proGuide.lastIndexOf(".")
        );
        // console.log('title',title);
        let formData = new FormData();
        formData.append("title", title); //文件名
        formData.append("checked_file", this.fileData); //文件
        formData.append("type", this.activeName); //类型

        this.axios({
          method: "post",
          url: "/japi/analysis/handle/",
          data: formData,
        }).then((res) => {
          this.loadingFile = false;
          if (res.data.code == 200) {
            console.log("整篇审查审查成功======");
            console.log(res);
            //遮罩隐藏
            this.$message({
              message: "整篇审查成功",
              type: "success",
              duration: 3000,
            });
            //上传成功返回uuid
            this.uuid = res.data.data[0].file_uuid;

            this.createCatalogDataFun(res.data.data[0].file_uuid, "file");
          } else if (res.data.code == 500) {
            this.$message({
              message: "整篇审查失败，请重新上传！",
              type: "warning",
              duration: 3000,
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      } else {
        this.$message({
          message: "请上传文件后进行审查！",
          type: "warning",
          duration: 3000,
        });
      }
    },
    //条目审查
    itemReviewFun() {
      if (this.itemCon) {
        //遮罩显示
        console.log(this.itemCon.substr(0, 20));
        this.loadingItem = true;
        let formData = new FormData();
        formData.append("title", this.itemCon.substr(0, 20)); //文件名
        formData.append("checked_item", this.itemCon); //条目
        formData.append("type", this.activeName); //类型

        this.axios({
          method: "post",
          url: "/japi/analysis/handle/",
          data: formData,
        }).then((res) => {
          if (res.data.code == 200) {
            console.log("条目审查成功======");
            console.log(res);
            //遮罩隐藏
            this.loadingItem = false;
            this.$message({
              message: "条目审查成功",
              type: "success",
              duration: 3000,
            });
            //上传成功返回uuid
            this.uuid = res.data.data[0].file_uuid;

            this.createCatalogDataFun(res.data.data[0].file_uuid, "item");
          } else if (res.data.code == 500) {
            this.$message({
              message: "条目审查失败，请重新上传！",
              type: "warning",
              duration: 3000,
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
      } else {
        this.$message({
          message: "请输入条目内容后进行审查！",
          type: "warning",
          duration: 3000,
        });
      }
    },
    //生成目录和全文
    createCatalogDataFun(uuid, type) {
      this.axios.put("/japi/analysis/handle/", { pk: uuid }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          console.log("生成目录成功======");
          if (type == "file") {
            //解决文件名无法重复上传的问题
            this.$refs.file.value = null;
          }
          //将uuid存储到localStorage
          window.localStorage.setItem("uuid", this.uuid); //审查文件uuid
          window.localStorage.setItem("reviewType", this.activeName); //审查类型
          window.localStorage.setItem("reviewStage", "checking"); //审查进度智能审查 "checking"  生成报告 "report" 完成审查 "done"
          //跳转智能审查详情页
          this.$router.push({ path: "/recordReview/recordReview" });
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../../assets/css/dialog.scss"; //弹窗样式
</style>
